import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  ProductFilterBerand,
  ProductFilterColor,
  ProductFilterCountry,
  ProductFilterProduct,
  ProductCreateProduct,
  ProductUpdateProduct,
  ProductFilterType,
  ProductFilterSeries,
  ProductFilterSeriesEnd,
  ProductFilterRam,
  ProductFilterRom,
  ProductFilterNetwork,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function ProductAE() {
  const [isLoading, setLoading] = useState(true);
  const [productType, setProductType] = useState([]);
  const [productRam, setProductRam] = useState([]);
  const [productRom, setProductRom] = useState([]);
  const [productNetwork, setProductNetwork] = useState([]);
  const [productSeries, setProductSeries] = useState([]);
  const [productSeriesEnd, setProductSeriesEnd] = useState([]);
  const [productCountry, setProductCountry] = useState([]);
  const [productColor, setProductColor] = useState([]);
  const [productBerand, setProductBerand] = useState([]);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();

  const start = async () => {
    try {
      if (id) {
        const ProductFilterProductData = await ProductFilterProduct({
          id: id,
        });
        if (
          ProductFilterProductData.status &&
          ProductFilterProductData.status === 200
        ) {
          console.log(ProductFilterProductData.data.data.data[0]);

          setForm(ProductFilterProductData.data.data.data[0]);
        }
      }
      const ProductFilterTypeData = await ProductFilterType({});
      if (
        ProductFilterTypeData.status &&
        ProductFilterTypeData.status === 200
      ) {
        setProductType(ProductFilterTypeData.data.data.data);
        const ProductFilterSeriesData = await ProductFilterSeries({});
        if (
          ProductFilterSeriesData.status &&
          ProductFilterSeriesData.status === 200
        ) {
          setProductSeries(ProductFilterSeriesData.data.data.data);
          const ProductFilterSeriesEndData = await ProductFilterSeriesEnd({});
          if (
            ProductFilterSeriesEndData.status &&
            ProductFilterSeriesEndData.status === 200
          ) {
            setProductSeriesEnd(ProductFilterSeriesEndData.data.data.data);

            const ProductFilterNetworkData = await ProductFilterNetwork({});
            if (
              ProductFilterNetworkData.status &&
              ProductFilterNetworkData.status === 200
            ) {
              setProductNetwork(ProductFilterNetworkData.data.data.data);

              const ProductFilterRamData = await ProductFilterRam({});
              if (
                ProductFilterRamData.status &&
                ProductFilterRamData.status === 200
              ) {
                setProductRam(ProductFilterRamData.data.data.data);

                const ProductFilterRomData = await ProductFilterRom({});
                if (
                  ProductFilterRomData.status &&
                  ProductFilterRomData.status === 200
                ) {
                  setProductRom(ProductFilterRomData.data.data.data);

                  const ProductFilterCountryData = await ProductFilterCountry(
                    {}
                  );
                  if (
                    ProductFilterCountryData.status &&
                    ProductFilterCountryData.status === 200
                  ) {
                    setProductCountry(ProductFilterCountryData.data.data.data);
                    const ProductFilterColorData = await ProductFilterColor({});
                    if (
                      ProductFilterColorData.status &&
                      ProductFilterColorData.status === 200
                    ) {
                      setProductColor(ProductFilterColorData.data.data.data);
                      const ProductFilterBerandData = await ProductFilterBerand(
                        {}
                      );
                      if (
                        ProductFilterBerandData.status &&
                        ProductFilterBerandData.status === 200
                      ) {
                        setProductBerand(
                          ProductFilterBerandData.data.data.data
                        );
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (form.symbol === "") {
      toast.error("سیمبل را وارد نمایید ");
      validation = false;
    }
    if (form.productColorId === "") {
      toast.error("رنگ را وارد نمایید ");
      validation = false;
    }
    if (form.productBerandId === "") {
      toast.error("برند را وارد نمایید ");
      validation = false;
    }
    if (form.productCountryId === "") {
      toast.error("کشور را وارد نمایید ");
      validation = false;
    }
    if (form.productTypeId === "") {
      toast.error("نوغ را وارد نمایید ");
      validation = false;
    }
    if (form.productSeriesId === "") {
      toast.error("سری را وارد نمایید ");
      validation = false;
    }
    if (form.productSeriesEndId === "") {
      toast.error("سری دوم را وارد نمایید ");
      validation = false;
    }
    if (form.productNetworkId === "") {
      toast.error("شبکه را وارد نمایید ");
      validation = false;
    }
    if (form.productRamId === "") {
      toast.error("رم را وارد نمایید ");
      validation = false;
    }
    if (form.productRomId === "") {
      toast.error("رام را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const ProductUpdateProductData = await ProductUpdateProduct(form);
          if (
            ProductUpdateProductData.status &&
            ProductUpdateProductData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Products");
          }
        } else {
          const ProductCreateProductData = await ProductCreateProduct(form);
          if (
            ProductCreateProductData.status &&
            ProductCreateProductData.status === 200
          ) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/Products");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
    console.log(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap">
              <div className="d-flex justify-content-start align-items-center w-100 m-2">
                <Select
                  className="m-2"
                  type="number"
                  name="productBerandId"
                  id="productBerandId"
                  text="برند"
                  value={form.productBerandId || ""}
                  onChange={handleChangeSearch}
                  option={productBerand.map((item) => {
                    let data = {
                      value: item.id,
                      title: item.name,
                    };
                    return data;
                  })}
                />
                <Select
                  className="m-2"
                  type="number"
                  name="productTypeId"
                  id="productTypeId"
                  text="نوع"
                  value={form.productTypeId || ""}
                  onChange={handleChangeSearch}
                  option={productType.map((item) => {
                    let data = {
                      value: item.id,
                      title: item.name,
                    };
                    return data;
                  })}
                />
                <Select
                  className="m-2"
                  type="number"
                  name="productSeriesId"
                  id="productSeriesId"
                  text="سری"
                  value={form.productSeriesId || ""}
                  onChange={handleChangeSearch}
                  option={productSeries.map((item) => {
                    let data = {
                      value: item.id,
                      title: item.name,
                    };
                    return data;
                  })}
                />
              </div>
              <div className="d-flex justify-content-start align-items-center w-100 m-2">
                <InputCus
                  className="m-2"
                  width="550px"
                  type="text"
                  name="name"
                  id="name"
                  text="نام"
                  value={form.name || ""}
                  onChange={handleChangeSearch}
                />
                <InputCus
                  className="m-2"
                  width="550px"
                  type="text"
                  name="symbol"
                  id="symbol"
                  text="سیمبل"
                  value={form.symbol || ""}
                  onChange={handleChangeSearch}
                />
              </div>
              <div className="d-flex justify-content-start align-items-center w-100 m-2">
                <Select
                  className="m-2"
                  type="number"
                  name="productSeriesEndId"
                  id="productSeriesEndId"
                  text="سری دوم"
                  value={form.productSeriesEndId || ""}
                  onChange={handleChangeSearch}
                  option={productSeriesEnd.map((item) => {
                    let data = {
                      value: item.id,
                      title: item.name,
                    };
                    return data;
                  })}
                />
                <Select
                  className="m-2"
                  type="number"
                  name="productRamId"
                  id="productRamId"
                  text="رم"
                  value={form.productRamId || ""}
                  onChange={handleChangeSearch}
                  option={productRam.map((item) => {
                    let data = {
                      value: item.id,
                      title: item.name,
                    };
                    return data;
                  })}
                />
                <Select
                  className="m-2"
                  type="number"
                  name="productRomId"
                  id="productRomId"
                  text="رام"
                  value={form.productRomId || ""}
                  onChange={handleChangeSearch}
                  option={productRom.map((item) => {
                    let data = {
                      value: item.id,
                      title: item.name,
                    };
                    return data;
                  })}
                />
              </div>
              <div className="d-flex justify-content-start align-items-center w-100 m-2">
                <Select
                  className="m-2"
                  type="number"
                  name="productNetworkId"
                  id="productNetworkId"
                  text="شبکه"
                  value={form.productNetworkId || ""}
                  onChange={handleChangeSearch}
                  option={productNetwork.map((item) => {
                    let data = {
                      value: item.id,
                      title: item.name,
                    };
                    return data;
                  })}
                />
                <Select
                  className="m-2"
                  type="number"
                  name="productCountryId"
                  id="productCountryId"
                  text="کشور"
                  value={form.productCountryId || ""}
                  onChange={handleChangeSearch}
                  option={productCountry.map((item) => {
                    let data = {
                      value: item.id,
                      title: item.name,
                    };
                    return data;
                  })}
                />

                <Select
                  className="m-2"
                  type=""
                  name="isInsurance"
                  id="isInsurance"
                  text="بیمه"
                  value={form.isInsurance || ""}
                  onChange={handleChangeSearch}
                  option={[
                    {
                      value: false,
                      title: "ندارد",
                    },
                    {
                      value: true,
                      title: "دارد",
                    },
                  ]}
                />
                <Select
                  className="m-2"
                  type="number"
                  name="productColorId"
                  id="productColorId"
                  text="رنگ"
                  value={form.productColorId || ""}
                  onChange={handleChangeSearch}
                  option={productColor.map((item) => {
                    let data = {
                      value: item.id,
                      title: item.name,
                    };
                    return data;
                  })}
                />
              </div>
            </div>
            <div className="d-flex flex-column justify-content-start align-items-start w-100 m-5">
              <span>پیش نمایش</span>
              <span>
                {productBerand.find((w) => w.id == form.productBerandId)?.name}{" "}
                {productType.find((w) => w.id == form.productTypeId)?.name}{" "}
                {productSeries.find((w) => w.id == form.productSeriesId)?.name}{" "}
                {form.name}{" "}
                {
                  productSeriesEnd.find((w) => w.id == form.productSeriesEndId)
                    ?.name
                }{" "}
                {productRam.find((w) => w.id == form.productRamId)?.name}
                {productRam.find((w) => w.id == form.productRamId)?.name && "/"}
                {productRom.find((w) => w.id == form.productRomId)?.name}{" "}
                {
                  productNetwork.find((w) => w.id == form.productNetworkId)
                    ?.name
                }{" "}
                {
                  productCountry.find((w) => w.id == form.productCountryId)
                    ?.name
                }{" "}
                {(form.isInsurance == "true" || form.isInsurance == true) &&
                  "Insurance"}{" "}
                {productColor.find((w) => w.id == form.productColorId)?.name}
              </span>
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductAE;
